import { useMutation } from "urql";

import { UpdateTradeInsuranceDocument } from "../../../graphql/generated.ts";

export const useUpdateTradeInsurance = () =>
  useMutation(UpdateTradeInsuranceDocument);
